import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';

const DatasetType = { Source:"source", Synthetic:"synthetic", Hybrid:"hybrid"};

@inject(DataService, Api, Router)
export class MachineDataset {
	/** Component methods **/
	constructor(ds, api, router){
		this.ds		= ds;
		this.api	= api;
		this.router = router;
		this.selectedDataset = null;
		this.editDataset	 = null;
		this.DatasetType	 = DatasetType;
	}

	activate(params){ this.id = params.id }

	attached(){
		// Load user datasets
		window.setTimeout( () => { this.init(); }, 300);
	}
	
	
	/** Custom methods **/
	init(){

		let machine = this.ds.app_data.machine;
		if(machine){
			this.machine = machine;
			this.dataset = this.ds.app_data.dataset;
		}
		else{
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
			})
		}
		
		
		let datasets = this.ds.app_data.datasets;
		if(!datasets){
			this.getUserDatasets().then(response =>{
				this.handleResponseUserDatasets(response);
			});
		}
		else{
			this.datasets = datasets;
		}
	}

	/** API Calls **/
	getUserDatasets(){
		let uid 	= this.ds.user.uid;
		let request = new Request("/api/v2/users/" +uid+ "/datasets/", "GET");
		return this.api.get(request);
	}
	
	handleResponseUserDatasets(response){
		let status = response.status;
		if(status === 200){
			let datasets 	= response.data;
			this.datasets 	=  datasets;
			this.ds.app_data.datasets = datasets;
		}
	}

	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}
	

	updateMachine(machine, fields){
		let request = new Request("/api/v2/machines/", "PUT");
		let body		= { machine: machine, fields:fields };
		request.body	= JSON.stringify(body);
		return this.api.put(request);
	}

	handleResponseMachineUpdate(response){
		// console.log("update response => ", response);
	}

	deleteDataset(id){
		// Request
		let request 	= new Request("/api/v2/datasets/id/_id?", "DELETE");
		let params  	= new URLSearchParams({ _id:id });
		request.url 	= request.url + params;
		return this.api.remove(request);
	}

	handleDeleteDataset(response){
		console.log("delete datset => ", response);	
	}

	postSyntheticDataset(req){
		/*	============================================
			Post synthetic dataset
			route => /api/v2/datasets/synthetic/
		*/
		// Create request
		let request 	= new Request("/api/v2/datasets/synthetic/", "POST");
		// Copy machine
		let req_machine	= { ... req.machine };
		// Edit machine
		req_machine.algorithm = "gen_synthetic_dataset"
		let body		= { machine:req_machine, dataset:req.dataset, oper:"gen_synthetic_dataset" };
		// Stringify req-body
		request.body	= JSON.stringify(body);
		return this.api.post(request);
	}

	handlePostSyntheticDataset(response){
		//console.log("response => ", response.data.dataset);
		return response;
	}

	postSummaryDataset(dataset){
		let id		= dataset._id;
		let req 	= new Request( "/api/v2/summary/","POST");
		let body 	= { dataset:dataset };
		req.body 	= JSON.stringify(body)
		// POST summary
		return this.api.post(req);
	}
	
	/** Transition methods **/
	// Next button action(submit)
	next(){
		let machine = this.ds.app_data.machine;
		let id		= machine._id
		let selectedDataset = this.selectedDataset.file_name
		// Update machine (frontend)
		machine.dataset = selectedDataset; // Path
		let dataset_info = { name:this.selectedDataset.name, size:this.selectedDataset.size };
		machine.dataset_info = dataset_info;
		
		this.ds.app_data.dataset = this.selectedDataset // Complete document
		this.updateMachine(machine, { "dataset":selectedDataset, "dataset_info":dataset_info }).then(response => {
			// Handle response
			this.handleResponseMachineUpdate(response);
		})
		.finally( () => {
			this.router.navigateToRoute("models.settings", { id: id });
		});
		
	}

	/** Action methods **/

	formatBytes(bytes, decimals = 2) {
		if (!+bytes) return '0 Bytes'
		const k = 1024
		const dm = decimals < 0 ? 0 : decimals
		const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
		const i = Math.floor(Math.log(bytes) / Math.log(k))
		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
	}
	
	
	// Select dataset

	// New Dataset
	newDataset(){
		let id		= this.id;
		// Navigate to new dataset
		this.router.navigateToRoute("models.dataset-new", { id:id })
	}

	removeDataset(dataset){
		let dataset_id = dataset._id;
		this.deleteDataset(dataset_id).then(response => {
			this.handleDeleteDataset(response);
		});
	}

	onSelectDatasetMenu(dataset){
		this.editDataset = dataset;
	}

	insertNewDataset(dataset){
		this.datasets = [dataset, ...this.datasets];
		//this.datasets.push(dataset);
	}

	// Generate synthetic dataset 
	generateSyntheticDataset(dataset){
		// Buffer machine
		let machine = { dataset:dataset.file_name, stats:{} };
		// Create synthetic data document
		let synth_document = { ... dataset}
		// Remove summary
		delete synth_document["summary"];
		let request = { machine:machine, dataset:synth_document };
		console.log("request dataset: ", request.dataset);
		this.postSyntheticDataset(request).then(response => {
			return this.handlePostSyntheticDataset(response)
		})
		.then(res => {
			// Update UI datasets
			let data 	= res.data
			let dataset = data.dataset;
			this.insertNewDataset(dataset);
			// Summary
			this.postSummaryDataset(dataset);
		});
	}
}
